import IBiometricsFilter from "../../models/misconfig/BiometricsFilter";
import React from "react";
import { Col, Row } from "react-bootstrap";

export interface IBiometricFilterItem {
    filter: IBiometricsFilter | undefined;
}

export default function BiometricFilterView(props: IBiometricFilterItem) {
    return (
        <React.Fragment>
            <Row>
                <Col md={12} className="pb-2"><i><b>Biometric filters</b></i></Col>
            </Row>
            <Row>
                <Col md={4} className="pb-2 ps-4"><b>Facial recognition</b></Col>
                <Col md={8}>{props?.filter?.FaceRecognition.join(", ")}</Col>
            </Row>
            <Row>
                <Col md={4} className="pb-2 ps-4"><b>Fingerprints</b></Col>
                <Col md={8}>{props?.filter?.Fingerprints.join(", ")}</Col>
            </Row>
        </React.Fragment>
    )
}